import { useState, useEffect } from "react";
import Masthead from "@/pages/home/components/Masthead";
import LiveBar from "@/pages/home/components/LiveBar";
import TopStory from "@/pages/home/components/TopStory";
import FlashList from "@/pages/home/components/FlashList";
import HotPanel from "@/pages/home/components/HotPanel";
import FeaturedZone from "@/pages/home/components/FeaturedZone";
import GalleryZone from "@/pages/home/components/GalleryZone";
import PublishBand from "@/pages/home/components/PublishBand";
import EditorLinks from "@/pages/home/components/EditorLinks";
import DownloadBand from "@/pages/home/components/DownloadBand";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Masthead />

      <LiveBar />

      <main>
        {/* sparse hero first */}
        <TopStory />

        {/* two-column live zone */}
        <div className="w-full bg-background-50">
          <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-10 px-4 pb-10 md:px-6 lg:grid-cols-[1.55fr_1fr] lg:gap-12">
            <FlashList />
            <HotPanel />
          </div>
        </div>

        {/* editorial features */}
        <FeaturedZone />

        {/* video gallery */}
        <GalleryZone />

        {/* submit teaser */}
        <PublishBand />

        {/* dense bottom */}
        <EditorLinks />
      </main>

      {/* prominent download band */}
      <DownloadBand />

      <Footer />

      {showTop ? (
        <button
          type="button"
          aria-label="回到顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-50 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl" />
        </button>
      ) : null}
    </div>
  );
}